$(document).on('turbo:load', function () {
  if (document.querySelector('div.not-signed-in')) {
    if(document.querySelector('div.alert.alert-danger')) {
      document.querySelector('div.alert.alert-danger').style.display = 'none'
    }
  }
})